import React from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useTranslation } from 'react-i18next';
import { getAuthFlow, type AuthFlow } from '@/config/authCopy';

function renderHeadline(title: string): React.ReactNode {
  const words = title.split(' ');
  return words.map((word, index, arr) => {
    const isItalic = index >= arr.length - 2;
    const suffix = index < arr.length - 1 ? ' ' : '';

    if (isItalic) {
      return (
        <em key={index}>
          {word}
          {suffix}
        </em>
      );
    }

    return (
      <span key={index}>
        {word}
        {suffix}
      </span>
    );
  });
}

function AuthMessage(): React.ReactElement {
  const { route } = useAuthenticator((context) => [context.route]);
  const { t } = useTranslation('auth');
  const flow: AuthFlow = getAuthFlow(route);

  return (
    <div className="auth-message">
      <span className="auth-message__stripe brand-stripe" aria-hidden />
      <h1 className="auth-message__headline">{renderHeadline(t(`${flow}.headline`))}</h1>
      <p className="auth-message__lede">{t(`${flow}.lede`)}</p>
    </div>
  );
}

export default AuthMessage;
